import * as React from 'react';
import './imageUpload.scss';
import {Icon} from '../Icon';
import {UserModel} from '../../../model/UserModel';
import ImageCompressor from 'image-compressor.js';
import {OrgModel} from '../../../model/OrgModel';
import { showAlert } from 'src/actions/miscellaneousActions';

export interface IImageUploadProps {
    instance: any;
    base64Image: string;
    Extensions?: any;
}

export interface IImageUploadState {
    base64Image: string;
    file: File;
    isLoading: boolean;
}

export class ImageUpload extends React.Component<IImageUploadProps, IImageUploadState> {
    constructor(props: IImageUploadProps) {
        super(props);
        let isInstancePropsNotEmpty = props && props.instance && props.instance.props && props.instance.props.ProfilePicFile;
        if (!isInstancePropsNotEmpty) {
            const OrgPicFile = props && props.instance && props.instance.props && props.instance.props.OrgPicFile;
            isInstancePropsNotEmpty = OrgPicFile || null;
        }
        this.state = {
            base64Image: props.base64Image,
            isLoading: false, file: isInstancePropsNotEmpty
        };
    }

    get images() {
        return this.state.file;
    }

    public handleFileUpload = async (e) => {
        
        const files = e.target.files[0];
        const fileContent = files['name'].split('.'); 
        const Ext = this.props.Extensions;
        if (this.props.Extensions !== undefined) {
            if (Ext.indexOf('image/' + fileContent[fileContent.length - 1].toLowerCase()) === -1) {
                showAlert({
                    title: 'Oops..!!',
                    text: `Only ${Ext.join(', ')} files allowed.`,
                    type: 'error',
                    closeOnConfirm: true
                },
                'submission'); 
                e.target.value = null;
                return;
            }
        }
        this.setState({
            isLoading: true
        });
        const self = this;
        /* tslint:disable */

        /* const fileReader = new FileReader();
        fileReader.onload = readFile;
        function readFile(e) {
            const name = new Date().getTime().toString();
            self.setState({
                base64Image: e.target.result,
                isLoading: false
            });
        }
        fileReader.readAsDataURL(files); */
        new ImageCompressor(files, {
            quality: 0.2, checkOrientation: false,
            success(result) {
                self.setState({
                    file: new File([result], result['name'], {type: result.type, lastModified: Date.now()}),
                    isLoading: false
                });
                const fileReader = new FileReader();
                fileReader.onload = readFile;
                fileReader.readAsDataURL(result);
            },
            error(error) {
                throw new Error();
            }
        });

        function readFile(event) {
            const base64Image = event.target.result;
            self.setState({
                base64Image,
                isLoading: false
            });
        }

        function readFile2(event) {
            const imageBase64 = event.target.result;
            resetOrientation(imageBase64, 5, function (resetBase64Image) {
                /* resetImage.src = resetBase64Image; */
                console.log(resetBase64Image);
                self.setState({
                    base64Image: resetBase64Image,
                    isLoading: false
                });
            });

            function resetOrientation(srcBase64, srcOrientation, callback) {
                console.log(srcBase64);
                var img = new Image();

                img.onload = function () {
                    var width = img.width,
                        height = img.height,
                        canvas = document.createElement('canvas'),
                        ctx = canvas.getContext('2d');

                    // set proper canvas dimensions before transform & export
                    if (4 < srcOrientation && srcOrientation < 9) {
                        canvas.width = height;
                        canvas.height = width;
                    } else {
                        canvas.width = width;
                        canvas.height = height;
                    }

                    // transform context before drawing image
                    switch (srcOrientation) {
                        case 2:
                            ctx.transform(-1, 0, 0, 1, width, 0);
                            break;
                        case 3:
                            ctx.transform(-1, 0, 0, -1, width, height);
                            break;
                        case 4:
                            ctx.transform(1, 0, 0, -1, 0, height);
                            break;
                        case 5:
                            ctx.transform(0, 1, 1, 0, 0, 0);
                            break;
                        case 6:
                            ctx.transform(0, 1, -1, 0, height, 0);
                            break;
                        case 7:
                            ctx.transform(0, -1, -1, 0, height, width);
                            break;
                        case 8:
                            ctx.transform(0, -1, 1, 0, 0, width);
                            break;
                        default:
                            break;
                    }

                    // draw image
                    ctx.drawImage(img, 0, 0);

                    // export base64
                    callback(canvas.toDataURL());
                };

                img.src = srcBase64;
            }

        }

    };

    public handleImageDelete = () => {
        this.setState({
            base64Image: null,
            file: null
        });
    };

    public render() {
        return <div className="image-upload">
            {this.state.isLoading ? <span>Loading Image...</span> : ''}
            {this.state.base64Image && !this.state.isLoading ? '' :
                <input type="file" multiple={false} accept={this.props.Extensions ? this.props.Extensions.join(', ') : ''} onChange={this.handleFileUpload}/>}
            {this.state.base64Image && !this.state.isLoading ?
                <div className="display-image">
                    <Icon icon="times" onClick={this.handleImageDelete}/>
                    <img src={this.state.base64Image}/>
                </div> : ''}
        </div>;
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/reusableComponents/ImageUpload/index.tsx